import { apiFetch } from './client';
import type { AuthUser } from '@/lib/auth-store';

export const invites = {
  lookup: (token: string) => apiFetch<{
    email: string; role: string; resellerName: string | null; displayName: string | null; expiresAt: string;
  }>(`/api/invites/${token}`),

  accept: (token: string, password: string) =>
    apiFetch<{ access_token: string; user: AuthUser }>(`/api/invites/${token}/accept`, {
      method: 'POST', body: JSON.stringify({ password }),
    }),
};
